import { useContext } from 'react';
import { useMediaQuery } from 'react-responsive';
import { pick } from 'lodash';
import { Button, Box } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import DataTableWrapper from 'src/components/DataTableWrapper';
import formatter from 'src/util/currencyFormatter';
import LeasedAssetContext from 'src/store/leased-asset-table-context';

const LeasedAssetDataTable = () => {
  const { leasedAssetModal, leasedAssetInfo } = useContext(LeasedAssetContext);
  const { leasedAssets, setInitialValues, initialValues, setUpdating } = leasedAssetInfo;

  const { leasedAssetModalController } = leasedAssetModal;

  const isDesktop = useMediaQuery({ query: '(min-width: 768px)' });

  const formatCurrency = (item) => formatter.format(item.value);

  const args = {
    title: 'Leased or Rented items',
    rows: leasedAssets,
    columns: [
      {
        field: 'lessorName',
        headerName: 'Lessor Name',
        flex: 1.5,
        minWidth: 120,
      },
      {
        field: 'descr',
        headerName: 'Description',
        flex: 2,
        minWidth: 250,
      },
      {
        field: 'dateOf',
        headerName: 'Date',
        flex: 0.75,
        minWidth: 110,
      },
      {
        field: 'quantity',
        headerName: 'Quanitity',
        flex: 0.5,
        minWidth: 80,
      },
      {
        field: 'term',
        headerName: 'Term',
        flex: 0.5,
        minWidth: 100,
      },
      {
        field: 'costOf',
        headerName: 'Cost',
        valueFormatter: formatCurrency,
        flex: 0.5,
        minWidth: 100,
      },
      {
        field: 'annualRent',
        headerName: 'Rent',
        valueFormatter: formatCurrency,
        flex: 0.5,
        minWidth: 100,
      },
    ],
    height: 700,
    rowClick: ({ row }) => {
      let existingValues = pick(row, [
        'lessorName',
        'lessorAddr',
        'lessorCity',
        'lessorState',
        'lessorZip',
        'agreementNo',
        'descr',
        'quantity',
        'dateOf',
        'costOf',
        'term',
        'annualRent',
      ]);
      setInitialValues(existingValues);
      setUpdating(row);
      leasedAssetModalController.openModal();
    },
  };

  return (
    <>
      <Box sx={{ mt: '2rem' }}>
        <DataTableWrapper {...args}>
          <Box>
            <Button
              variant="outlined"
              onClick={() => {
                setInitialValues(initialValues);
                leasedAssetModalController.openModal();
              }}
            >
              <AddIcon sx={{ mr: '0.125rem', fontSize: '1.4rem' }} />
              {isDesktop && <span>Add Leased Asset</span>}
            </Button>
          </Box>
        </DataTableWrapper>
      </Box>
    </>
  );
};

export default LeasedAssetDataTable;
